import { ThemeProvider } from 'emotion-theming';
import React from 'react';
import { ClientContextProvider } from 'react-fetching-library';
import { DriverPortalClient } from 'services/clients/DriverPortalClient';
import { theme } from '../configs/styled';
import { AuthProvider } from './authContext';

const AppProvider: React.FC = props => {
  const { children } = props;
  return (
    <ClientContextProvider client={DriverPortalClient}>
      <ThemeProvider theme={theme}>
        <AuthProvider>{children}</AuthProvider>
      </ThemeProvider>
    </ClientContextProvider>
  );
};

export default AppProvider;
